import { CommonModule } from '@angular/common';
import { Component, computed, EventEmitter, inject, Input, Output } from '@angular/core';

import { AuthService } from '../core/auth/auth.service';
import { UserService } from '../core/user/user.service';

@Component({
  selector: 'app-topbar',
  standalone: true,
  imports: [CommonModule],
  template: `
    <header class="topbar wd-100">
      <div class="title-area">
        <button type="button" class="menu-button" (click)="navigationToggle.emit()" aria-label="Toggle navigation"><i class="pi pi-bars"></i></button>
        <div><span>Platform / {{pageTitle}}</span><h1>{{pageTitle}}</h1></div>
      </div>
      <div class="user-area">
        <div class="avatar">{{initials()}}</div>
        <div class="identity"><strong>{{displayName()}}</strong><span>{{user().email || 'Signed in via ACP cidaas'}}</span></div>
        <button type="button" class="logout" (click)="logout()">Logout</button>
      </div>
    </header>
  `,
  styles: [`
    :host{display:block;min-width:0}.topbar{min-height:92px;display:flex;align-items:center;justify-content:space-between;gap:20px;padding:20px;border:1px solid var(--border-color);border-radius:20px;background:var(--card-background);box-shadow:0 12px 30px #1d2e4809}.title-area,.user-area{display:flex;align-items:center;gap:13px}.title-area span{color:var(--text-secondary-color);font-size:.72rem;font-weight:800;letter-spacing:.09em;text-transform:uppercase}.title-area h1{margin:4px 0 0;color:var(--text-color);font-size:1.55rem}.menu-button{display:none;width:42px;height:42px;border:0;border-radius:12px;background:var(--background-color);color:var(--text-color);cursor:pointer}.avatar{width:44px;height:44px;display:grid;place-items:center;border-radius:14px;background:#17233b;color:#fff;font-weight:800}.identity{display:grid}.identity strong{color:var(--text-color)}.identity span{color:var(--text-secondary-color);font-size:.76rem}.logout{min-height:42px;border:1px solid #eed1d9;border-radius:11px;padding:.62rem .85rem;background:var(--card-background);color:var(--brand-color);font-weight:750;cursor:pointer}.menu-button:focus-visible,.logout:focus-visible{outline:3px solid color-mix(in srgb,var(--brand-color) 24%,transparent);outline-offset:2px}
    @media(max-width:1100px){.menu-button{display:block}}@media(max-width:700px){.topbar{align-items:flex-start;padding:16px}.identity{display:none}.title-area h1{font-size:1.25rem}.user-area{margin-left:auto}.avatar{display:none}}
  `]
})
export class TopbarComponent {
  @Input() pageTitle = 'Dashboard';
  @Output() readonly navigationToggle = new EventEmitter<void>();

  private readonly authService = inject(AuthService);
  private readonly userService = inject(UserService);
  readonly user = this.userService.currentUser;
  readonly displayName = computed(() => {
    const currentUser = this.user();
    const fullName = [currentUser.givenName, currentUser.familyName].filter(Boolean).join(' ');
    const result = fullName || currentUser.email || 'Authenticated user';
    return result;
  });
  readonly initials = computed(() => {
    const currentUser = this.user();
    const nameParts = [currentUser.givenName, currentUser.familyName].filter(Boolean);
    const result = nameParts.length > 0
      ? nameParts.map((part) => part[0]?.toUpperCase() ?? '').join('').slice(0, 2)
      : (currentUser.email || 'AU').slice(0, 2).toUpperCase();
    return result;
  });

  logout(): void {
    this.authService.logout();
  }
}
